/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1CourseregistrationSharedClassStudentListQueryResponse,
  GetApiV1CourseregistrationSharedClassStudentListQueryParams,
  GetApiV1CourseregistrationSharedClassStudentList401,
  GetApiV1CourseregistrationSharedClassStudentList500,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedClassStudentList.ts";

function getGetApiV1CourseregistrationSharedClassStudentListUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/courseregistration/shared/class-student-list` as const,
  };
  return res;
}

/**
 * @description Retorna as turmas ativas filtradas por curso, empresa e opcionalmente apenas turmas com monografia. Quando o parâmetro 'mainOnly' é verdadeiro e nenhuma empresa é informada, retorna apenas turmas sem empresa vinculada. A empresa do usuário autenticado sobrepõe o parâmetro 'companyId' quando aplicável. **(Requer Authorization para autenticação)**
 * @summary Retorna a lista de turmas para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/shared/class-student-list}
 */
export async function getApiV1CourseregistrationSharedClassStudentList(
  params?: GetApiV1CourseregistrationSharedClassStudentListQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1CourseregistrationSharedClassStudentListQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationSharedClassStudentList401
      | GetApiV1CourseregistrationSharedClassStudentList500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1CourseregistrationSharedClassStudentListUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
